module.exports = __webpack_public_path__ + "RobotoMedium.f83f3de5ee93e1a36b72.svg";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoMedium.svg
// module id = ../../../../../src/fonts/RobotoMedium.svg
// module chunks = 3